import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ApiKeyCrudService } from '../api-key/types';
import { ActionCreator, TypedAction } from '@ngrx/store/src/models';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ApiKeyFormApiError, ApiKeyFormApiErrorTypes } from './api-key-form.errors';
import { getErrorType } from '../../shared/utils/error.utils';
import {
  ApiKeyCreatedProps,
  ApiKeyErroredProps,
  ApiKeyRequestedProps,
  ApiKeyLoadedProps,
} from './types';

export abstract class ApiKeyFormCrudEffects {
  protected constructor(protected actions$: Actions, protected apiKeyService: ApiKeyCrudService) {}

  protected getApiKeyByIdEffect(
    requestedAction: ActionCreator<
      string,
      (props: ApiKeyRequestedProps) => ApiKeyRequestedProps & TypedAction<string>
    >,
    successAction: ActionCreator<
      string,
      (props: ApiKeyLoadedProps) => ApiKeyLoadedProps & TypedAction<string>
    >,
    failedAction: ActionCreator<
      string,
      (props: ApiKeyErroredProps) => ApiKeyErroredProps & TypedAction<string>
    >,
  ) {
    return createEffect(() =>
      this.actions$.pipe(
        ofType(requestedAction),
        switchMap(({ apiKeyId }) =>
          this.apiKeyService.getApiKeyById(apiKeyId).pipe(
            map((apiKey) => successAction({ apiKey })),
            catchError((err) =>
              of(
                failedAction({
                  error: new ApiKeyFormApiError(
                    getErrorType(ApiKeyFormApiErrorTypes, err.status),
                    err,
                  ),
                }),
              ),
            ),
          ),
        ),
      ),
    );
  }

  protected createApiKeyEffect(
    requestedAction: ActionCreator<
      string,
      (props: ApiKeyCreatedProps) => ApiKeyCreatedProps & TypedAction<string>
    >,
    successAction: ActionCreator<
      string,
      (props: ApiKeyLoadedProps) => ApiKeyLoadedProps & TypedAction<string>
    >,
    failedAction: ActionCreator<
      string,
      (props: ApiKeyErroredProps) => ApiKeyErroredProps & TypedAction<string>
    >,
  ) {
    return createEffect(() =>
      this.actions$.pipe(
        ofType(requestedAction),
        switchMap((action) =>
          this.apiKeyService.createApiKey(action.apiKey).pipe(
            map((apiKey) => successAction({ apiKey })),
            catchError((err) =>
              of(
                failedAction({
                  error: new ApiKeyFormApiError(
                    getErrorType(ApiKeyFormApiErrorTypes, err.status),
                    err,
                  ),
                }),
              ),
            ),
          ),
        ),
      ),
    );
  }
}
